module.exports = __webpack_public_path__ + "static/media/Asset 5_6.a15f3933.png";